
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[station]",
      function () {
        return require("private-next-pages/[station].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[station]"])
      });
    }
  